/* eslint-disable no-console */
import * as util from "util";
import { Logger } from "../models";
import { createStructuredLogJson } from "../createStructuredLogJson";

export function createConsoleLogger(
  name: string,
  defaultContext?: Record<string, unknown>,
): Logger {
  const _context: Record<string, unknown> = { ...defaultContext };

  return {
    get context() {
      return { ..._context };
    },
    addContext(entries: Record<string, unknown>) {
      Object.assign(_context, entries);
    },
    debug(
      msg: string,
      context?: Record<string, unknown>,
      error?: unknown,
    ): void {
      const logString = createStructuredLogJson(
        name,
        "debug",
        msg,
        { ..._context, ...context },
        error,
      );
      if (logString) {
        console.debug(logString);
      }
    },
    error(
      msg: string,
      context?: Record<string, unknown>,
      error?: unknown,
    ): void {
      const logString = createStructuredLogJson(
        name,
        "error",
        msg,
        { ..._context, ...context },
        error,
      );
      if (logString) {
        console.error(logString);
      }
    },
    info(
      msg: string,
      context?: Record<string, unknown>,
      error?: unknown,
    ): void {
      const logString = createStructuredLogJson(
        name,
        "info",
        msg,
        { ..._context, ...context },
        error,
      );
      if (logString) {
        console.info(logString);
      }
    },
    warn(
      msg: string,
      context?: Record<string, unknown>,
      error?: unknown,
    ): void {
      const logString = createStructuredLogJson(
        name,
        "warn",
        msg,
        { ..._context, ...context },
        error,
      );
      if (logString) {
        console.warn(logString);
      }
    },
    child(childName: string) {
      return createConsoleLogger([name, childName].join("."), { ..._context });
    },
  };
}
